import Model, { attr } from '@ember-data/model';

import type { APIData } from 'webapp-types';
import type { VerificationInfo } from 'webapp/utils/verification';

import type { DefaultTitleInfo } from 'webapp/models-custom/custom-query';
import type { StatusObjectAction, StatusObjectType } from 'webapp/models-custom/status-object';

export default class CustomQueryRecord extends Model {
	@attr('string', { defaultValue: 'My built metric' }) queryName!: string;
	@attr('number') created!: number;
	@attr('number') createdById!: number;
	@attr('number') modified!: number | null;
	@attr('number') modifiedById!: number | null;
	@attr('number') sourceId!: number;
	@attr('number') sourceToId!: number;
	@attr('string') statusLevel!: string;
	@attr('string') statusTitle!: string;
	@attr('string') statusDescription!: string;
	@attr('string') statusAction!: StatusObjectAction | null;
	@attr('string') statusType!: StatusObjectType | null;
	@attr('string') statusUserResponseLink!: string;
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	settings!: APIData.CustomQuery.SettingsData;
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	transformations!: APIData.CustomQuery.TransformationsData;
	@attr('number') cloneFrom!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	tags!: number[];
	@attr('number') originateFrom!: number;
	@attr('boolean') migrateData!: boolean;
	@attr('number') preferredVisualization!: number;
	@attr('boolean') isFromPublicTemplate!: boolean;
	@attr('object') defaultTitle!: DefaultTitleInfo | null; // sending default column titles for google sheets
	@attr('object') verificationInfo?: VerificationInfo;
}
